import { Box, DashboardModule, Form } from '@domain-group/suit-theme'

import useOrderItems from '@hooks/useOrderItems'

import OrderItemListItem from '../OrderItemListItem'

interface OrderItemsProps {
  orderId: number,
}
const OrderItems = (props: OrderItemsProps) => {
  const { orderId } = props

  const itemsPayload = useOrderItems({ filters: { order_id: orderId } })
  const {
    filteredOrderItems,
    hasFilteredOrderItems,
    loading,
  } = itemsPayload

  return (
    <>
      {/*
       // @ts-expect-error TS2741 */}
      <Form.Field label="Items" marginTop="large" />
      {!hasFilteredOrderItems && !loading && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Items present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please assign a Item
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {hasFilteredOrderItems && !loading && (
        <Box
          flexDirection="column"
          maxHeight="300"
          overflowY="auto"
        >
            {filteredOrderItems.map(item => <OrderItemListItem item={item} />)}
        </Box>
      )}
    </>
  )
}

export default OrderItems
